<template>
  <div class="privacy-policy">
    <navbar show-home title="隐私政策" />
    <p>
      【特别提示】请仔细阅读《黑卡PLUS隐私政策》（尤其是加粗划线的内容）并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询，如您不同意协议中的任何条款，您应立即停止访问黑卡PLUS。阅读协议的过程中，如果您不同意相关协议或其中任何条款约定，您应立即停止使用黑卡PLUS。
    </p>
    <h1>《黑卡PLUS隐私政策》正文</h1>
    版本更新日期：2019年12月26日 <br />引言
    <br />黑卡PLUS（“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《黑卡PLUS隐私政策》（“本隐私政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。
    <br />本隐私政策将帮助您了解以下内容：
    <br />一、我们如何收集和使用您的个人信息 <br />二、我们如何使用 Cookies
    和同类技术 <br />三、我们如何共享、转让、公开披露您的个人信息
    <br />四、我们如何保护和保存您的个人信息 <br />五、您如何管理个人信息
    <br />六、未成年人的个人信息保护 <br />七、通知和修订 <br />八、如何联系我们
    <br />
    <b class="underline"
      >本隐私政策与您所使用的黑卡PLUS商城服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本隐私政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。</b
    >
    <br />如对本隐私政策或相关事宜有任何问题，您可拨打我们的客服电话400-6687017与我们联系
    。
    <br />
    <b>一、我们如何收集和使用您的个人信息</b>
    <br />个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
    <b>本隐私政策</b
    >中涉及的个人信息包括：基本信息（包括个人姓名、生日、性别、住址、个人电话号码）；网络身份标识信息（包括系统账号、IP地址及与前述有关的密码、口令、口令保护答案）；个人财产信息（交易和消费记录、以及福利金、推广业绩等虚拟财产信息）；个人上网记录（包括网站浏览记录）；个人位置信息（包括、精准定位信息、经纬度等）；
    <br />
    <b>个人敏感信息</b
    >是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，
    <b>本隐私政策</b>中涉及的
    <b>个人敏感信息包括</b
    >：您的财产信息（包括交易记录及以及福利金、推广业绩等虚拟财产信息）；网络身份识别信息（包括账号、邮箱地址及与前述有关的密码口令的组合）；其他信息（包括网页浏览记录、精准定位信息）。
    <br />我们仅会出于以下目的，收集和使用您的个人信息：
    <br />
    <b>（一）您须授权我们收集和使用您个人信息的情形</b>
    <br />
    <b>
      我们的产品与/或服务包括一些核心功能，这些功能包含了实现网上购物所必须的功能及保障交易安全所必须的功能。
      <em class="underline"
        >我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品与/或服务。这些功能包括：</em
      >
    </b>
    <br />
    <b>1、实现网上购物所必须的功能</b>
    <br />
    <b>（1）用户注册</b>
    <br />您首先需要注册一个黑卡PLUS账户成为黑卡PLUS用户。
    <em class="underline"
      >当您注册时，您需要至少向我们提供您准备使用的黑卡PLUS账户名、密码、您本人的手机号码，我们将通过发送短信验证码的方式来验证您的身份是否有效。</em
    >您的账户名为您的默认昵称，您可以修改补充您的昵称、性别、生日，这些信息均属于您的“账户信息”。您补充的账户信息将有助于我们为您提供个性化的商品推荐和更优的购物体验，但如果您不提供这些补充信息，不会影响您网上购物的基本功能。
    <br />
    <b>（2）商品信息展示和搜索</b>
    <br />
    <b class="underline"
      >为了让您快速地找到您所需要的商品，我们可能会收集您使用我们的产品与/或服务的设备信息（包括设备名称、设备型号、设备识别码、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络ID（PLMN））、浏览器类型来为您提供商品信息展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息。</b
    >
    <br />您也可以通过搜索来精准地找到您所需要的商品或服务。我们会保留您的搜索内容以方便您重复输入或为您展示与您搜索内容相关联的商品。
    <b class="underline"
      >请您注意，您的搜索关键词信息无法单独识别您的身份，不属于您的个人信息，我们有权以任何的目的对其进行使用；只有当您的搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本隐私政策对其进行处理与保护。</b
    >
    <br />为了将您感兴趣的商品或服务信息展示给您，或在您搜索时向您展示您可能希望找到的商品，我们可能会收集您的订单信息、浏览信息进行数据分析以形成用户画像。我们还可能为了提供服务及改进服务质量的合理需要而获得的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、个性化内容和建议。如果您不希望受个性化内容的影响，您可以在商品展示页选择按照分类进行浏览和查找商品和服务；我们还在搜索结果中向该您提供了按照价格、销量排序等不针对个人特征的选项；未经您的明确同意，我们不会将您的相关个人信息提供给第三方。
    <br />
    <b>（3）下单</b>
    <br />当您准备对您购物车内的商品进行结算时，黑卡PLUS系统会生成您购买该商品的订单。
    <b class="underline"
      >您需要在订单中至少填写您的收货人姓名、收货地址以及手机号码，同时该订单中会载明订单号、您所购买的商品或服务信息、您应支付的货款金额及支付方式；您可以另外填写收货人的固定电话、邮箱地址信息以增加更多的联系方式确保商品可以准确送达，但不填写这些信息不影响您订单的生成。</b
    >
    <br />上述所有信息构成您的“订单信息”，我们将使用您的订单信息来进行您的身份核验、确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务；我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。
    <br />
    <b>（4）支付功能</b>
    <br />在您下单后，您可以选择黑卡PLUS的关联方或与黑卡PLUS合作的第三方支付机构（微信支付等支付通道，以下称“支付机构”）所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的黑卡PLUS订单号与交易金额信息与这些支付机构共享以实现其确认您的支付指令并完成支付。“关联方”指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的法定代表人。“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。
    <br />
    <b>（5）交付产品与/或服务功能</b>
    <br />在当您下单并选择货到付款或在线完成支付后，黑卡PLUS的关联方或与黑卡PLUS合作的第三方配送公司（包括顺丰、圆通等，以下称“配送公司”）将为您完成订单的交付。您知晓并同意黑卡PLUS的关联方或与黑卡PLUS合作的第三方配送公司会在上述环节内使用您的订单信息以保证您的订购的商品能够安全送达。
    <br />
    <b>（6）客服与售后功能</b>
    <br />我们的电话客服和售后功能会使用您的账号信息和订单信息。
    <br />为保证您的账号安全，我们的呼叫中心客服和在线客服会使用您的账号信息与您核验您的身份。当您需要我们提供与您订单信息相关的客服与售后服务时，我们将会查询您的订单信息。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息，如当您要求我们变更配送地址、联系人或联系电话。
    <br />
    <b>（二）您可自主选择提供的个人信息的情形</b>
    <br />1、为使您购物更便捷或更有乐趣，从而提升您在黑卡PLUS的网上购物体验，我们的以下扩展功能中可能会收集和使用您的个人信息。
    <b
      >如果您不提供这些个人信息，您依然可以进行网上购物，但您可能无法使用这些可以为您所带来购物乐趣的扩展功能或在购买某些商品时需要重复填写一些信息。</b
    >这些扩展功能包括：
    <br />
    <b class="underline"
      >（1）基于位置信息的个性化推荐功能：我们会收集您的位置信息（我们仅收集您当时所处的地理位置，但不会将您各时段的位置信息进行结合以判断您的行踪轨迹）来判断您所处的地点，自动为您推荐您所在区域可以购买的商品或服务。</b
    >比如向您推荐离您所在地有库存充足的商品。 <br />（2）
    <b>基于图片上传的扩展功能：</b
    >您可以在黑卡PLUS上传您的照片来实现拍照发送售后问题，
    <b>我们会使用您所上传的图片或视频来处理您提出的售后问题。</b>
    <br />2、上述扩展功能可能需要您在您的设备中向我们开启您的地理位置（位置信息）、相机（摄像头）、相册（图片库）的访问权限，以实现这些功能所涉及的信息的收集和使用。您可以在您的设备的授权管理中逐项查看您上述权限的开启状态，并可以决定将这些权限随时的开启或关闭。
    <b class="underline"
      >请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。</b
    >
    <br />
    <b
      >（三）您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</b
    >
    <br />
    <b class="underline">1、与国家安全、国防安全有关的；</b>
    <br />
    <b class="underline">2、与公共安全、公共卫生、重大公共利益有关的；</b>
    <br />
    <b class="underline">3、与犯罪侦查、起诉、审判和判决执行等有关的；</b>
    <br />
    <b class="underline"
      >4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</b
    >
    <br />
    <b class="underline"
      >5、所收集的个人信息是个人信息主体或监护人自行向社会公众公开的；</b
    >
    <br />
    <b class="underline"
      >6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</b
    >
    <br />
    <b class="underline">7、根据您的要求签订合同所必需的；</b>
    <br />
    <b class="underline"
      >8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</b
    >
    <br />
    <b class="underline">9、为合法的新闻报道所必需的；</b>
    <br />
    <b class="underline"
      >10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</b
    >
    <br />
    <b class="underline">11、法律法规规定的其他情形。</b>
    <br />
    <b>（四）我们从第三方获得您个人信息的情形</b>
    <br />我们可能从第三方获取您授权共享的账户信息（头像、昵称），并在您同意本隐私政策后将您的第三方账户与您的黑卡PLUS账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。
    <br />
    <b>（五）您个人信息使用的规则</b>
    <br />1、我们会根据本隐私政策的约定并为实现我们的产品与/或服务功能对所收集的个人信息进行使用。
    <br />2、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。
    <b class="underline"
      >请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</b
    >
    <br />3、请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息，具体请详见本隐私政策附件《黑卡PLUS账户注销须知》。
    <br />4、我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。
    <br />5、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。
    <br />6、当我们要将您的个人信息用于本隐私政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意。
    <br />
    <b>二、我们如何使用 Cookies 和同类技术</b>
    <br />
    <b>（一）Cookies的使用</b>
    <br />1、为实现您联机体验的个性化需求，使您获得更轻松的访问体验。我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies
    是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、存储您的购物偏好或您购物车中的商品等数据进而为您提供购物的偏好设置、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账户或数据安全。
    <br />2、我们不会将 Cookies
    用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除
    Cookies。您可以清除计算机上保存的所有
    Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝
    Cookies；另外，您也可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每一次访问黑卡PLUS网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。
    <br />
    <b>（二）网络Beacon和同类技术的使用</b>
    <br />除Cookies
    外，我们还会在网站上使用网络Beacon等其他同类技术。我们的网页上常会包含一些电子图像（称为"单像素"
    GIF 文件或 "网络 Beacon"）。我们使用网络Beacon的方式有：
    <br />1、通过在黑卡PLUS网站上使用网络Beacon，计算用户访问数量，并通过访问
    Cookies 辨认注册的黑卡PLUS用户。
    <br />2、通过得到的Cookies信息，为您提供个性化服务。
    <br />
    <b>三、我们如何共享、转让、公开披露您的个人信息</b>
    <br />
    <b>（一）共享</b>
    <br />
    <b
      >1、我们不会与黑卡PLUS以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</b
    >
    <br />（1）事先获得您明确的同意或授权；
    <br />（2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；
    <br />（3）在法律法规允许的范围内，为维护黑卡PLUS、黑卡PLUS的关联方或合作伙伴、您或其他黑卡PLUS用户或社会公众利益、财产或安全免遭损害而有必要提供；
    <br />（4）
    只有共享您的个人信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务；
    <br />（5）应您需求为您处理您与他人的纠纷或争议；
    <br />（6）符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；
    <br />（7）基于学术研究而使用；
    <br />（8）基于符合法律法规的社会公共利益而使用。
    <br />
    <b
      >2、我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。</b
    >
    <br />
    <b
      >3、我们可能会向合作伙伴等第三方共享您的订单信息、账户信息、设备信息以及位置信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</b
    >我们的合作伙伴包括以下类型： <br />（1）商品或技术服务的供应商。
    <b class="underline">我们可能会将您的个人信息共享给支持我们功能的第三方。</b
    >这些支持包括为我们的供货或提供基础设施技术服务、物流配送服务、支付服务、数据处理等。我们共享这些信息的目的是可以实现我们产品与/或服务的核心购物功能，比如我们必须与物流服务提供商共享您的订单信息才能安排送货；或者我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的支付指令并完成支付等。
    <br />（2）第三方商家。
    <b class="underline"
      >我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。</b
    >
    <br />（3）委托我们进行推广的合作伙伴。有时我们会代表其他企业向使用我们产品与/或服务的用户群提供促销推广的服务。
    <b class="underline"
      >我们可能会使用您的个人信息以及您的非个人信息集合形成的间接用户画像与委托我们进行推广的合作伙伴（“委托方”）共享，但我们仅会向这些委托方提供推广的覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便它不会识别您个人。</b
    >比如我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。
    <br />4、对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。为了保障数据在第三方安全可控，我们推出了云鼎服务，在云端提供安全可靠的数据使用和存储环境，确保用户数据的安全性。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。
    <br />5、为了遵守法律、执行或适用我们的使用条件和其他协议，或者为了保护黑卡PLUS、您或其他黑卡PLUS客户的权利及其财产或安全，比如为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过,这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。
    <br />
    <b>（二）转让</b>
    <br />我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
    <br />1、事先获得您明确的同意或授权；
    <br />2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；
    <br />3、符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；
    <br />
    <b class="underline"
      >4、在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。</b
    >
    <br />
    <b>（三）公开披露</b>
    <br />我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：
    <br />1、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；
    <br />2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。
    <br />
    <b>四、我们如何保护和保存您的个人信息</b>
    <br />
    <b>（一）我们保护您个人信息的技术与措施</b>
    <br />我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：
    <br />
    <b>1、数据安全技术措施</b>
    <br />我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。
    <br />黑卡PLUS的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。
    <br />黑卡PLUS采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离。
    <br />在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、SHA256在内多种数据脱敏技术增强个人信息在使用中安全性。
    <br />黑卡PLUS采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。
    <br />黑卡PLUS采用代码安全自动检查、数据访问日志分析技术进行个人信息安全审计。
    <br />
    <b
      >2、我们仅允许有必要知晓这些信息的黑卡PLUS及黑卡PLUS关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与黑卡PLUS的合作关系。</b
    >
    <br />
    <b>3、我们会采取一切合理可行的措施，确保未收集无关的个人信息。</b
    >我们只会在达成本隐私政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
    <br />4、互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。
    <br />
    <b>5、安全事件处置</b>
    <br />在通过黑卡PLUS网站与第三方进行网上商品或服务的交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址等。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。
    在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、电话等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
    <br />6、如果您对我们的个人信息保护有任何疑问，可通过本隐私政策中约定的联系方式联系我们。
    <b
      >如您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即通过本隐私政策【八、如何联系我们】中约定的联系方式联络我们，以便我们采取相应措施。</b
    >
    <br />
    <b>（二）您个人信息的保存</b>
    <br />1、您的个人信息将存储于中华人民共和国境内。如您使用跨境交易服务，且需要向境外传输您的个人信息完成交易的，我们会单独征得您的授权同意并要求接收方按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理这些个人信息。
    <br />
    <b class="underline"
      >2、请您注意，当您成功注销黑卡PLUS账户后，我们将对您的个人信息进行删除或匿名化处理。</b
    >
    <br />
    <b class="underline"
      >3、如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</b
    >
    <br />
    <b>五、您如何管理您的个人信息</b>
    <br />黑卡PLUS非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
    <br />
    <b>1、访问和更正您的个人信息</b>
    <br />除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：
    <br />（1）您的账户信息：首页--“我的”进入我的黑卡PLUS-- “个人资料”。
    <br />（2）您的订单信息：首页--“我的”进入我的黑卡PLUS—订单管理。
    <br />（4）您的浏览信息：您可以访问或清除您的搜索历史记录、查看和修改兴趣以及管理其他数据。路径为：搜索历史记录：首页--“我的”进入我的黑卡PLUS--浏览记录；兴趣及其他数据：首页--“我的”进入我的黑卡PLUS--商品关注、店铺关注、内容关注、喜欢的活动。
    <br />（5）对于您在使用我们的产品与/或服务过程中产生的其他个人信息需要访问或更正，请随时联系我们。我们会根据本隐私政策所列明的方式和期限响应您的请求。
    <br />（6）您无法访问和更正的个人信息：除上述列明的信息外，您的部分个人信息我们还无法为您提供访问和更正的服务，这些信息主要是为了提升您的用户体验和保证交易安全所收集的您的设备信息、您使用扩展功能时产生的个人信息。上述信息我们会在您的授权范围内进行使用，您无法访问和更正，但您可联系我们进行删除或做匿名化处理。
    <br />
    <b>2、删除您的个人信息</b>
    <br />您在我们的产品与/或服务页面中可以直接清除或删除的信息，包括订单信息、浏览信息；
    <br />
    <b>在以下情形中，您可以向我们提出删除个人信息的请求：</b>
    <br />（1）如果我们处理个人信息的行为违反法律法规；
    <br />（2）如果我们收集、使用您的个人信息，却未征得您的同意；
    <br />（3）如果我们处理个人信息的行为违反了与您的约定；
    <br />（4）如果我们终止服务及运营。
    <br />若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。若我们响应您的删除请求，我们不能保证立即从备份系统中删除相应的信息，但会在备份系统更新时删除这些信息。
    <br />
    <b>3、改变您授权同意的范围或撤回您的授权</b>
    <br />
    <b class="underline"
      >您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。</b
    >
    <br />
    <b class="underline"
      >请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</b
    >
    <br />
    <b>4、账户注销</b>
    <br />
    <b class="underline"
      >您可以联系我们的客服提出注销黑卡PLUS账户的需求。关于您注销账户的方式以及您应满足的条件，请详见本隐私政策附件《黑卡PLUS账户注销须知》。您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。</b
    >
    <br />5、为了保护您的隐私，我们不会以任何方式和途径向您推送涉及宗教信仰、性等相关敏感内容的促销或商品信息给您。
    <br />
    <b>6、响应您的请求</b>
    <br />如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息，或您认为黑卡PLUS存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以通过拨打客服电话的方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或提供您的身份证明文件，我们将在收到您反馈并验证您的身份后的15天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
    <br />在以下情形中，按照法律法规要求，我们将无法响应您的请求：
    <br />（1）与国家安全、国防安全有关的；
    <br />（2）与公共安全、公共卫生、重大公共利益有关的；
    <br />（3）与犯罪侦查、起诉和审判等有关的；
    <br />（4）有充分证据表明您存在主观恶意或滥用权利的；
    <br />（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
    <br />
    <b>六、未成年人的个人信息保护</b>
    <br />1、我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您家长或法定监护人的书面同意。我们将根据国家相关法律法规的规定保护未成年人的个人信息。
    <br />2、对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
    <br />3、如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
    <br />
    <b>七、通知和修订</b>
    <br />1、为给您提供更好的服务以及随着黑卡PLUS业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在黑卡PLUS网站、黑卡PLUS移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问黑卡PLUS以便及时了解最新的隐私政策。
    <br />2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。
    <br />本隐私政策所指的重大变更包括但不限于：
    <br />（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
    <br />（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
    <br />（3）个人信息共享、转让或公开披露的主要对象发生变化；
    <br />（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；
    <br />（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
    <br />（6）个人信息安全影响评估报告表明存在高风险时。
    <br />3、我们还会将本隐私政策的旧版本存档，供您查阅。
    <br />
    <b>八、如何联系我们</b>
    <br />1、如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请联系黑卡PLUS客服。
    <br />客服电话：400-6687017
    <br />您还可以通过黑卡PLUS在线客服系统与我们联系。
    <br />2、一般情况下，我们将在15天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报。
    <br />注：本隐私政策版本更新日期为2019年12月26日。
    <br />
    <b>附件：《黑卡PLUS账户注销须知》</b>
    <br />亲爱的黑卡PLUS个人消费者用户：
    <br />您在申请注销前，应当认真阅读《黑卡PLUS账户注销须知》（以下称“《注销须知》”）。
    <br />请您务必审慎阅读、充分理解《注销须知》中相关条款内容，其中包括：
    <br />1、与您约定免除或限制责任的条款； <br />2、其他以粗体标识的重要条款。
    <br />如您对本《注销须知》有任何疑问，可拨打我们的客服电话联系客服
    <br />我们在此善意地提醒您，
    <b
      >您注销账户的行为会给您的售后维权带来诸多不便，且注销黑卡PLUS账户后，您的个人信息我们只会在黑卡PLUS商城的前台系统中去除，使其保持不可被检索、访问的状态，或对其进行匿名化处理。您知晓并理解，根据相关法律规定，相关交易记录须在黑卡PLUS后台保存1年甚至更长的时间。</b
    >
    <br />
    <b>1、如果您仍执意注销账户，您的账户需同时满足以下条件：</b>
    <br />（1）自愿放弃账户在黑卡PLUS商城系统中的资产和虚拟权益（包括但不限于账户福利金、推广业绩收入等）；
    <br />（2）账户内无未完成的订单和服务；
    <br />（3）账户无任何纠纷，包括投诉举报或被投诉举报；
    <br />2、黑卡PLUS账户一旦被注销将不可恢复，请您在操作之前自行备份黑卡PLUS账户相关的所有信息和数据。请您保存好订单商品和服务的交易凭证等资料，否则您有可能须支付额外的账户和订单查询费用，或无法享受售后服务。
    <br />3、在黑卡PLUS账户注销期间，如果您的黑卡PLUS账户涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，黑卡PLUS有权自行终止本黑卡PLUS账户的注销而无需另行得到您的同意。
    <br />
    <b
      >4、注销黑卡PLUS账户，您将无法再使用本黑卡PLUS账户，也将无法找回您黑卡PLUS账户中及与账户相关的任何内容或信息，包括但不限于：</b
    >
    <br />（1）您将无法登录、使用本黑卡PLUS账户；
    <br />（2）本黑卡PLUS账户的个人资料和历史信息（包括但不限于用户名、头像、购物记录等）都将无法找回；
    <br />5、注销本黑卡PLUS账户并不代表本黑卡PLUS账户注销前的账户行为和相关责任得到豁免或减轻。
  </div>
</template>

<script>
import Navbar from '../components/NavBar'
export default {
  name: 'privacyPolicy',
  components: {
    Navbar
  }
}
</script>

<style lang="less" scoped>
.privacy-policy {
  padding: 0.3rem 0.2rem;
  background-color: #fff;
  font-size: @fz24;
  color: @base;
  line-height: 1.5;
  h1 {
    font-size: @fz28;
    font-weight: bold;
  }
  .underline {
    font-weight: bold;
    text-decoration: underline;
  }
}
</style>
